<template>
	<div>
		<v-data-table
			v-if="hasItens"
			:headers="colunas"
			:items="dataSource"
			:server-items-length="totalItens"
			item-key="id"
			:options="paginacaoInterna"
			no-data-text="Não há atas cadastradas"
			hide-default-footer
		>
			<template #item.percentagem="{ item }">
				<span>{{ item.percentagem }}%</span>
			</template>
			<template #item.quantidadeAditada="{ item }">
				<span>{{ item.quantidadeAditada }}</span>
			</template>
			<template #item.estoqueAnterior="{ item }">
				<span>{{ item.estoqueAnterior | rpCurrencyFilter('', numeroCasasDecimaisQtde) }}</span>
			</template>
			<template #item.estoqueNovo="{ item }">
				<span>{{ item.estoqueNovo | rpCurrencyFilter('', numeroCasasDecimaisQtde) }}</span>
			</template>
			<template #item.dataCadastro="{ item }">
				<span>{{ item.dataCadastro | formatDataHourMinuteFilter }}</span>
			</template>
		</v-data-table>
		<paginacao-tabela
			v-if="hasItens"
			:total-paginas="totalPaginas"
			:total-itens="totalItens"
			:page.sync="paginacaoInterna.page"
			:rows-per-page.sync="paginacaoInterna.rowsPerPage"
			@resetar-page="resetarPage"
			@paginar="setPaginacaoHistorico"
		></paginacao-tabela>
		<template-listagem-vazia :textos="textos" :total-itens="totalItens"></template-listagem-vazia>
	</div>
</template>

<script>
import { TabelaColunaUtils } from '@/core/utils'
import { actionTypes, mutationTypes } from '@/core/constants'
import PaginacaoListagem from '@/core/store/default/paginacaoListagem'

export default {
	name: 'historico-aditamento-item',
	components: {},
	data() {
		return {
			dataSource: [],
			colunas: [
				new TabelaColunaUtils('Percentual Anterior', 'percentagem', '15%'),
				new TabelaColunaUtils('Novo Percentual', 'quantidadeAditada', '15%'),
				new TabelaColunaUtils('Saldo Anterior', 'estoqueAnterior', '20%'),
				new TabelaColunaUtils('Saldo Novo', 'estoqueNovo', '20%'),
				new TabelaColunaUtils('Usuário', 'usuario.nome', '15%'),
				new TabelaColunaUtils('Data/Hora', 'dataCadastro', '15%'),
			],
			paginacaoInterna: PaginacaoListagem(['id'], 5, 'DESC'),
			totalPaginas: 0,
			totalItens: 0,
			textos: {
				titulo: 'Não há históricos por aqui',
			},
		}
	},
	computed: {
		numeroCasasDecimaisQtde: {
			get() {
				return this.$store.state.ata.informacoesAta.numeroCasasDecimaisQtde
			},
		},
		hasItens() {
			return this.totalItens > 0
		},
	},
	watch: {
		paginacaoInterna: {
			handler(novoValor) {
				this.setPaginacaoHistorico(novoValor)
			},
			deep: true,
		},
	},
	async mounted() {
		this.resetarPage()
		await this.carregarHistoricos()
	},

	methods: {
		async carregarHistoricos() {
			const { itens, totalElements, totalPages } = await this.$store.dispatch(
				actionTypes.ITEM_ATA.ADITAMENTO.HISTORICO.BUSCAR_HISTORICOS,
				this.$store.state.itemAta.itensAtaSelecionados[0].id,
			)
			this.dataSource = itens
			this.totalItens = totalElements
			this.totalPaginas = totalPages
			this.carregando = false
		},
		resetarPage() {
			this.$store.commit(mutationTypes.ITEM_ATA.ADITAMENTO.HISTORICO.RESETAR_PAGINA_LISTAGEM)
		},
		async setPaginacaoHistorico(paginacao) {
			this.$store.commit(mutationTypes.ITEM_ATA.ADITAMENTO.HISTORICO.SET_PAGINACAO_LISTAGEM, paginacao)
			await this.carregarHistoricos()
		},
	},
}
</script>
<style lang="stylus" scoped></style>
